<template>
  <div class="report grid">
    <!--<div class="estimate-number my1">
      <span class="uppercase semibold wide font-size-1">Low</span>
      <span class="font-size-7 block extra-condensed medium price mb1">{{ estimate.lowPrice | currency }}</span>
      <hr class="mb1">
      <span class="font-size-5 wide medium block left">{{ estimate.lowTime | round2 }}</span>
      <span class="wide semibold font-size-1 uppercase left label">Labour<br>{{ rateUnit[estimate.rateType].label }}s</span>
    </div>
    <div class="estimate-number my1">
      <span class="uppercase semibold wide font-size-1">High</span>
      <span class="font-size-7 block extra-condensed medium price mb1">{{ estimate.highPrice | currency }}</span>
      <hr class="mb1">
      <span class="font-size-5 wide medium block left">{{ estimate.highTime | round2 }}</span>
      <span class="wide semibold font-size-1 uppercase left label">Labour<br>{{ rateUnit[estimate.rateType].label }}s</span>
    </div-->
    <div class="estimate-number align-right order-1_sm">
      <span class="uppercase semibold wide font-size-2">Estimate range</span>
      <span
        v-if="estimate.showRedFlags"
        class="font-size-8 block extra-condensed medium mb1 accent-text"><span class="inline-block">{{ estimate.lowMidPrice | currency }}</span> &ndash; <span class="inline-block">{{ estimate.midHighPrice | currency }}</span></span>
      <span
        v-else
        class="font-size-8 block extra-condensed medium mb1 accent-text"><span class="inline-block">{{ estimate.lowPrice | currency }}</span> &ndash; <span class="inline-block">{{ estimate.highPrice | currency }}</span></span>
      <div class="block right">
        <span
          v-if="estimate.showRedFlags"
          class="font-size-5 wide left medium">{{ estimate.lowMidTime | round }}&ndash;{{ estimate.midHighTime | round }}</span>
        <span
          v-else
          class="font-size-5 wide left medium">{{ estimate.lowTime | round }}&ndash;{{ estimate.highTime | round }}</span>
        <span class="wide semibold font-size-1 uppercase left align-left label">Labour<br>{{ rateUnit[estimate.rateType].label }}s <lw-tip :content="'Labour ' + rateUnit[estimate.rateType].label + 's are the number of billable ' + rateUnit[estimate.rateType].label + 's your team will use to complete the project. Not the project duration.'"/></span>
      </div>
    </div>
    <div class="range">
      <lw-range-graph
        v-if="estimate.showRedFlags"
        :max="estimate.highTime"
        :max-price="estimate.highPrice"
        :mid-max-price="estimate.midHighPrice"
        :mid="estimate.midTime"
        :mid-max="estimate.midHighTime"
        :mid-price="estimate.midPrice"
        :min="estimate.lowTime"
        :min-mid="estimate.lowMinTime"
        :min-price="estimate.lowPrice"
        :min-mid-price="estimate.lowMidPrice"
        :spread="3"
        :unit="rateUnit[estimate.rateType].label"
      />
      <lw-range-graph
        v-else
        :max="estimate.highTime"
        :max-price="estimate.highPrice"
        :min="estimate.lowTime"
        :min-price="estimate.lowPrice"
        :unit="rateUnit[estimate.rateType].label"
      />
    </div>

    <!--<div class="estimate-number my1">
      <span class="uppercase semibold wide font-size-2">Target</span>
      <span class="font-size-8 block extra-condensed medium price mb1">{{ estimate.midPrice | currency }}</span>
      <hr class="mb1">
      <span class="font-size-5 wide medium block left">{{ estimate.midTime | round2 }}</span>
      <span class="wide semibold font-size-1 uppercase left label">Labour<br>{{ rateUnit[estimate.rateType].label }}s</span>
    </div>-->
  </div>
</template>

<script>
import RangeGraph from '../livewires/RangeGraph'
import Tip from '../livewires/Tip'

export default {
  components: {
    lwRangeGraph: RangeGraph,
    lwTip: Tip
  },
  data () {
    return {
      page: this.$route.params.id
    }
  },
  computed: {
    estimate () {
      return this.$store.getters.estimate(this.page)
    },
    rateUnit () {
      return this.$store.getters.rateUnits(this.estimate.rateCard)
    }
  }
}
</script>

<style scoped>
  .estimate-number .font-size-8 {
    line-height: 0.705;
  }
  .estimate-number {
    margin-bottom: calc(var(--line) * 0.5);
  }
  .label {
    margin-top:0.5em;
    margin-left: 0.33em;
    line-height: 1;
  }
  .range {
    margin-bottom: var(--line);
  }
  @media screen and (min-width: 48em) {
    .report {
      grid-template-columns: 2fr 3fr;
      margin-top: calc(var(--line) * 1);
    }
    .range {
      margin-top: calc(var(--line) * 1.5);
      margin-bottom: calc(var(--line) * 5);
      margin-left: calc(var(--line)* 1.5);
    }
  }
  @media screen and (min-width: 64em) {
    .report {
      grid-template-columns: 1fr 1fr;
    }
    .range {
      margin-left: 0;
    }
  }
  @media screen and (min-width: 98em) {
    .report {
      grid-template-columns: 2fr 1fr;
    }
  }
</style>
